<template>
	<div>
		<egranty-section-divider
			text="Udostępnione sprawozdania z naborów"
		/>
		<div v-for="report in reports" :key="report.id">
			<v-card>
				<v-layout row>
					<h3 style="padding: 10px">{{report.projectCode}} &emsp; {{report.projectTitle}}</h3>
					<egranty-icon-button
						label="Podgląd"
						icon="assignment"
						@click="() => viewReport(report)"
					/>
				</v-layout>
			</v-card>
		</div>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";
	import {AgencyFinalReport} from "../../../api/generated/AgencyFinalReport";

	export default {
		name: "AllowedAgencyReportsView",
		components: {EgrantyIconButton, EgrantySectionDivider},

		data () {
			return {
				reports: []
			};
		},

		methods: {
			viewReport (report) {
				this.$router.openInNewTab("/view/agency-contest/" + report.contestId + "/final-report/" + report.projectId);
			}
		},

		created () {
			AgencyFinalReport.getAllowedBasicData(this, successResponse => {
					this.reports = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować sprawozdań", errorResponse);
				});
		}
	};
</script>

<style scoped>

</style>